import React from "react";
import { push } from "connected-react-router";
import _ from "lodash";
import { Path } from "path-parser";
import HomeIcon from "@material-ui/icons/Home";
import SettingsIcon from "@material-ui/icons/Settings";
import Share from "@material-ui/icons/Share";
import ErrorOutlineOutlinedIcon from "@material-ui/icons/ErrorOutlineOutlined";
import PublicInstrument from "./containers/publicinstrument/views";

import AllSetting from "./containers/setting/views/index";
import AddSplitForInstrument from "./containers/setting/views/SplitInstrument/AddSplitForInstrument";
import ProviderErrorList from "./containers/errorMonitoring/views";

const SplitInstrument = React.lazy(() =>
  retry(() =>
    import("./containers/setting/views/SplitInstrument/SplitInstrument")
  )
);

const AddPI = React.lazy(() =>
  retry(() => import("./containers/publicinstrument/views/add"))
);

const AddReferrer = React.lazy(() =>
  retry(() => import("./containers/setting/views/addReferrer"))
);
const ConnectionSessionData = React.lazy(() =>
  retry((O) => import("./containers/connectionsessiondata/views/index"))
);

const menu = [
  {
    path: "/publicInstrument",
    name: "publicinstrument",
    icon: <HomeIcon />,
    title: "Public Instruments",
    key: "publicinstrument",
    homepage: true,
    component: <PublicInstrument />,
  },
  {
    path: "/addpi",
    name: "AddPI",
    icon: <HomeIcon />,
    title: "Add Public Instrument",
    key: "addpi",
    dontShowOnMenu: true,
    component: <AddPI />,
  },
  {
    path: "/setting",
    name: "setting",
    icon: <SettingsIcon />,
    title: "Admin functions",
    key: "allSetting",
    component: <AllSetting />,
  },
  {
    path: "/addreferrer",
    name: "AddReferrer",
    icon: <HomeIcon />,
    title: "Add Referrer",
    key: "addpi",
    dontShowOnMenu: true,
    component: <AddReferrer />,
  },
  {
    path: "/splitinstrument",
    name: "SplitInstrument",
    icon: <SettingsIcon />,
    title: "Split Instrument",
    key: "SplitInstrument",
    component: <SplitInstrument />,
  },
  {
    path: "/addsplitforinstrument",
    name: "addsplitforinstrument",
    icon: <HomeIcon />,
    title: "Add Split For Instrument",
    key: "addsplitforinstrument",
    dontShowOnMenu: true,
    component: <AddSplitForInstrument />,
  },
  {
    path: "/connectionsessiondata",
    name: "connectionsessiondata",
    icon: <Share />,
    title: "Connection Session Data",
    key: "connectionsessiondata",
    component: <ConnectionSessionData />,
  },
  {
    path: "/providererrorlist",
    name: "providererrorlist",
    icon: <ErrorOutlineOutlinedIcon />,
    title: "Provider Error List",
    key: "ProviderErrorList",
    component: <ProviderErrorList />,
  },
];

export const getUrlPushWrapper = (keyString, query) => {
  return push(getUrlPath(keyString, query));
};

export const getUrlPath = (keyString, params) => {
  if (!params) params = {};

  let keyArr = keyString.split(".");
  let val = _.find(menu, (p) => p.key === keyArr[0]);

  if (!val) {
    return `/`;
  }

  if (keyArr.length === 2) {
    val = _.find(val.children, (p) => p.key === keyArr[1]);
  }

  if (!val) {
    return `/`;
  }

  let queryString = Object.keys(params)
    .map((key) => key + "=" + params[key])
    .join("&");

  return `${val.path}?${queryString}`;
};

export const getPushPathWrapper = (keyString, params) => {
  let obj = getUrlObject(keyString);

  if (obj) {
    const path = new Path(obj.path);

    return push(path.build(params));
  }

  return "error";
};

export const getUrlParams = (keyString, route) => {
  let obj = getUrlObject(keyString);

  if (obj) {
    const path = new Path(obj.path);
    return path.test(route);
  }

  return { error: true };
};

export const getUrlObject = (keyString) => {
  let keyArr = keyString.split(".");
  let val = _.find(menu, (p) => p.key === keyArr[0]);
  if (!val) {
    return `/`;
  }

  if (keyArr.length === 2) {
    val = _.find(val.children, (p) => p.key === keyArr[1]);
  }

  if (!val) {
    return `/`;
  }

  return val;
};

function retry(fn, retriesLeft = 5, interval = 1000) {
  return new Promise((resolve, reject) => {
    fn()
      .then(resolve)
      .catch((error) => {
        setTimeout(() => {
          if (retriesLeft === 1) {
            // reject('maximum retries exceeded');
            reject(error);
            return;
          }

          // Passing on "reject" is the important part
          retry(fn, retriesLeft - 1, interval).then(resolve, reject);
        }, interval);
      });
  });
}
//</editor-fold>
export default menu;
